import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";

export default function BulkConvertDialog({ prospects, open, onOpenChange, onDone }) {
  const [sel, setSel] = useState([]);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  useEffect(() => { if (open) { setSel(prospects.map((p) => p.id)); setResult(null); } }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/prospects/convert-bulk", { ids: sel });
      setResult(data); toast.success(`${data.created} client(s) créé(s) · ${data.linked} relié(s)`); onDone();
    } catch (e) { toast.error(apiErr(e)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="bulk-convert-dialog">
        <DialogHeader><DialogTitle className="font-head">Convertir les prospects gagnés</DialogTitle></DialogHeader>
        {result ? (
          <div className="space-y-2 text-sm" data-testid="bulk-convert-result">
            <p><b className="text-emerald-700">{result.created}</b> client(s) créé(s)</p>
            <p><b className="text-sky-700">{result.linked}</b> prospect(s) relié(s) à un client existant</p>
            <p><b className="text-rose-600">{result.errors.length}</b> échec(s)</p>
            {result.errors.map((e) => <p key={e.id} className="text-xs text-rose-600 pl-3">• {e.nom || e.id} : {e.detail}</p>)}
          </div>
        ) : (
          <>
            <p className="text-xs text-slate-500">Un client existant avec le même e-mail, téléphone ou nom sera relié au lieu d'être recréé.</p>
            <div className="flex justify-between text-xs">
              <button type="button" className="text-brand-700 hover:underline" onClick={() => setSel(prospects.map((p) => p.id))} data-testid="bulk-select-all">Tout cocher</button>
              <button type="button" className="text-slate-500 hover:underline" onClick={() => setSel([])} data-testid="bulk-select-none">Tout décocher</button>
            </div>
            <div className="max-h-72 overflow-y-auto space-y-1">
              {prospects.map((p) => (
                <label key={p.id} className="flex items-center gap-2 rounded-md border px-3 py-2 text-sm cursor-pointer hover:bg-slate-50">
                  <Checkbox checked={sel.includes(p.id)} onCheckedChange={() => toggle(p.id)} data-testid={`bulk-check-${p.id}`} />
                  <span className="font-medium">{p.nom} {p.prenom}</span>
                  <span className="text-xs text-slate-400 truncate">{p.entreprise || p.email || p.telephone}</span>
                </label>
              ))}
            </div>
          </>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="bulk-close">Fermer</Button>
          {!result && <Button onClick={run} disabled={busy || !sel.length} className="bg-brand-600 hover:bg-brand-700 text-white" data-testid="bulk-convert-confirm">{busy ? "Conversion…" : `Convertir (${sel.length})`}</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
